<template>
  <div v-if="visible" class="magic-ui-toast">
    {{ text }}
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch, ref } from 'vue';
import { MComponent } from '@tmagic/schema';
import Core from '@tmagic/core';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
}>();

const app: Core | undefined = useApp(props);
const node = app?.page?.getNode(props.config.id);
const text = ref(props.config.text);
const { pureVisible, visible, show, hide } = useDisplay(props);

watch( () => props.config.text, (val) => {
  text.value = val;
})
// 原始的visible属性变化为true时，计时关闭
watch(
  () => pureVisible.value,
  (val, oldVal) => {
    if (props.config.duration && val && val !== oldVal) {
      const timeout = props.config.duration;
      setTimeout(() => {
        hide();
      }, timeout);
    }
  }
);
const setText = (text: string) => {
  text.value = text;
}
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  value: text,
  show,
  hide,
});

defineExpose(exportInterface);
</script>
